import { connect } from "react-redux";

import { RootState } from "store/store";
import { getErrorMessage } from "store/common/initialization/initialization-selectors";

import ErrorSection from "./ErrorSection";

const mapStateToProps = (state: RootState) => {
    return {
        errorMessage: getErrorMessage(state),
    };
};

const ErrorSectionContainer = connect(mapStateToProps)(ErrorSection);

export default ErrorSectionContainer;
